module.exports = __webpack_public_path__ + "static/media/autostraighten_after.bac57cd3.jpg";